module.exports = __webpack_public_path__ + "static/img/5.c38fcab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/commonality/20251009/5.jpg
// module id = t12j
// module chunks = 7